import * as _ from 'lodash';

import * as types from './types';

const INITIAL_STATE = {
  caseTypeMapping: [],
  caseTypeMappingInitial: [],
  redirectHome: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.DC_SET_CASE_TYPE_MAPPING:
      const mappings = payload.map(element => ({
        key: element.ExternalField,
        value: element.InternalField,
      }));

      return {
        ...state,
        caseTypeMapping: mappings,
        caseTypeMappingInitial: _.cloneDeep(mappings),
      };

    case types.DC_SET_REDIRECT_HOME:
      return {
        ...state,
        redirectHome: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/fileconfig/reducer.js